module.exports = __webpack_public_path__ + "static/offset_comp_604264_car-loan-22785640f8ed186318bbcb1fbab80ebb.jpg";